import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignSetupHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';

function JourneysAutomationsSetupRoute() {
  const { campaignId } = Route.useParams();
  return <JourneysCampaignSetupHandoff campaignId={campaignId} step="index" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/')(
  {
    component: JourneysAutomationsSetupRoute,
  },
);
